export const clearedFilters = {
    amountOrdered: '',
    dateOrdered: '',
    pricePerUnit: '',
    supplier: '',
    status: '',
    sort: 'dateOrdered',
    order: 'desc',
    page: 1,
};
